/* eslint-disable */
import {
	Geometry2d,
	RecordProps,
	Rectangle2d,
	ShapeUtil,
	SVGContainer,
	T,
	TLBaseShape,
	TLResizeInfo,
	resizeBox,
	TLDefaultColorStyle,
	DefaultColorStyle,
	getDefaultColorTheme,
} from "tldraw";
import { TLIconDefaultColor } from "@/helper";

type ICustomShape = TLBaseShape<
	"round_table_10",
	{
		w: number;
		h: number;
		color: TLDefaultColorStyle;
	}
>;

// [2]
export class RoundTable10Element extends ShapeUtil<ICustomShape> {
	static override type = "round_table_10" as const;
	static override props: RecordProps<ICustomShape> = {
		w: T.number,
		h: T.number,
		color: DefaultColorStyle as any,
	};

	// [b]
	getDefaultProps(): ICustomShape["props"] {
		return {
			w: 14,
			h: 16,
			color: TLIconDefaultColor,
		};
	}

	// [c]
	override canEdit() {
		return true;
	}
	override canResize() {
		return true;
	}
	override isAspectRatioLocked() {
		return false;
	}

	// [d]
	getGeometry(shape: ICustomShape): Geometry2d {
		return new Rectangle2d({
			width: shape.props.w,
			height: shape.props.h,
			isFilled: true,
		});
	}

	// [e]
	override onResize(shape: ICustomShape, info: TLResizeInfo<any>) {
		return resizeBox(shape, info);
	}

	// [f]
	component(shape: ICustomShape) {
		const theme = getDefaultColorTheme({ isDarkMode: false });
		const themeColor = theme[shape.props.color] as { solid: string };
		const fill = themeColor.solid;
		return (
			<SVGContainer>
				<svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
					<path
						d="M28,3v4c0,.552-.447,1-1,1h-6c-.553,0-1-.448-1-1V3c0-1.654,1.346-3,3-3h2c1.654,0,3,1.346,3,3ZM36,24c0-6.617-5.383-12-12-12s-12,5.383-12,12,5.383,12,12,12,12-5.383,12-12ZM11.425,12.998c.052.008.104.012.156.012.21,0,.416-.066.588-.191l4.854-3.527c.446-.325.546-.95.222-1.397l-2.352-3.236c-.972-1.337-2.852-1.635-4.19-.664l-1.618,1.176c-.648.471-1.074,1.167-1.199,1.958-.126.792.064,1.584.536,2.232l2.352,3.236c.155.214.391.358.652.4ZM9.067,14.942l-3.803-1.236c-1.574-.51-3.269.353-3.781,1.926l-.618,1.902h0c-.511,1.574.354,3.27,1.927,3.78l3.805,1.236c.101.033.204.049.309.049.156,0,.312-.037.454-.109.236-.121.415-.33.497-.582l1.854-5.707c.171-.525-.117-1.089-.643-1.26ZM4.339,34.44c.307,0,.618-.047.925-.147l3.804-1.236c.525-.171.813-.735.643-1.26l-1.854-5.707c-.082-.252-.261-.461-.497-.582-.235-.12-.511-.142-.763-.06l-3.805,1.236c-1.573.511-2.438,2.207-1.927,3.78l.618,1.902h0c.412,1.267,1.591,2.073,2.855,2.073ZM12.462,44.576c.929,0,1.845-.429,2.432-1.235l2.351-3.236c.324-.447.225-1.072-.222-1.397l-4.854-3.527c-.214-.156-.482-.221-.744-.179-.262.042-.497.186-.652.4l-2.352,3.236c-.472.648-.662,1.441-.536,2.232.125.792.551,1.487,1.199,1.958l1.618,1.176c.531.386,1.148.572,1.76.572ZM21,40c-.553,0-1,.448-1,1v4c0,1.654,1.346,3,3,3h2c1.654,0,3-1.346,3-3v-4c0-.552-.447-1-1-1h-6ZM39.579,38.638l-2.352-3.236c-.155-.214-.391-.358-.652-.4-.262-.042-.53.022-.744.179l-4.854,3.527c-.446.325-.546.95-.222,1.397l2.352,3.236c.586.807,1.502,1.235,2.431,1.235.611,0,1.229-.186,1.76-.572l1.618-1.176c.648-.471,1.074-1.167,1.199-1.958.126-.792-.064-1.584-.536-2.232ZM45.208,26.685l-3.805-1.236c-.25-.082-.526-.06-.763.06-.236.121-.415.33-.497.582l-1.854,5.707c-.171.525.117,1.089.643,1.26l3.803,1.236c.308.1.619.147.926.147,1.265,0,2.443-.807,2.855-2.073l.618-1.902h0c.511-1.574-.354-3.27-1.927-3.78ZM42.736,13.707l-3.804,1.236c-.525.171-.813.735-.643,1.26l1.854,5.707c.082.252.261.461.497.582.142.072.298.109.454.109.104,0,.208-.016.309-.049l3.805-1.236c1.573-.511,2.438-2.207,1.927-3.78l-.618-1.902h0c-.512-1.573-2.208-2.436-3.78-1.926ZM36.575,12.998c.262-.042.497-.186.652-.4l2.352-3.236c.472-.648.662-1.441.536-2.232-.125-.792-.551-1.487-1.199-1.958l-1.618-1.176c-1.338-.971-3.218-.674-4.191.664l-2.351,3.236c-.324.447-.225,1.072.222,1.397l4.854,3.527c.172.125.378.191.588.191.052,0,.104-.004.156-.012Z"
						fill={fill}
					/>
				</svg>
			</SVGContainer>
		);
	}

	// [g]
	indicator() {
		return;
	}
}
